import React, { Component } from 'react';
import RequestDetailModal from '../../../travel-expense/detail/index';
import ExchangeRateInput from '../../exchange-rate/component/index';
import ChangeExchangeRateButton from '../../exchange-rate/button';
import InputModal from '../../../common/modal/input/index';
import ApproveButton from '../../approve/button';
import RejectButton from '../../reject/button';
import ConfirmModal from '../../../common/modal/confirm';
import RejectComponents from '../../reject/component';

class AccountingActionView extends Component {
  constructor(props) {
    super(props);

    this.approveButtonAction = this.approveButtonAction.bind(this);
    this.rejectButtonAction = this.rejectButtonAction.bind(this);
  }

  async approveButtonAction() {
    const { request, actionButtonEvents } = this.props;

    actionButtonEvents.approveRequest({
      harcirahId: request._id,
      exchangeRate: request.exchangeRate,
      currency: request.calculatedAmount.abroadCurrency
    });
  }

  async rejectButtonAction({harcirahId, description}) {
    const { actionButtonEvents } = this.props;

    actionButtonEvents.rejectedRequest({
      harcirahId,
      description
    });
  }

  render() {
    const { request, actionButtonEvents, isOverLimitCheckExist } = this.props;
    const waitingForCancelled = request && request.status === 'waiting_for_accounting_cancelled';

    if (request.status === 'accounting' || request.status === 'pending') {
      return (
        <div>
          <RequestDetailModal
            isManager
            request={request}
          />
          <span>
              &nbsp;
          </span>
        {request.type === "abroad" &&
         <span>
         <InputModal
            title="Döviz kurunu değiştirin"
            trigger={ChangeExchangeRateButton}
            submit={actionButtonEvents.approveRequest}
            submitLabel="Onayla"
            Component={ExchangeRateInput}
            ComponentProps={{
              harcirahId: request._id,
              currency: request.calculatedAmount.abroadCurrency,
            }}
          />
          <span>
             &nbsp;
          </span>
         </span>
          }


          <ConfirmModal
            title="Emin misiniz?"
            trigger={ApproveButton}
            confirm={this.approveButtonAction}
          >
            <h3>
                            Talep Onaylanacak
            </h3>
          </ConfirmModal>

          {isOverLimitCheckExist &&
           <span>
            <InputModal
            title="Harcırah reddedilecek"
            trigger={RejectButton}
            //triggerInfo={waitingForCancelled}
            submit={this.rejectButtonAction}
            submitLabel="Talep Reddedilecek"
            Component={RejectComponents}
            ComponentProps={{ harcirahId: request._id }}
          />
          <span>
             &nbsp;
          </span>
         </span>
          }
        </div>
      );
    }

    if (request.status === 'waiting_for_accounting_cancelled') {
      return (
        <div>
          <RequestDetailModal
            isManager
            request={request}
          />
          <span>
                  &nbsp;
          </span>

          <ConfirmModal
            title="Emin misiniz?"
            trigger={ApproveButton}
            triggerInfo={waitingForCancelled}
            confirm={this.approveButtonAction}
          >
            <h3>
                          Talep Onaylanacak
            </h3>
          </ConfirmModal>
            <span>
                &nbsp;
            </span>
            <InputModal
                title="İptal Talebi Reddedilecek"
                trigger={RejectButton}
                //triggerInfo={waitingForCancelled}
                submit={this.rejectButtonAction}
                submitLabel="Talep Reddedilecek"
                Component={RejectComponents}
                ComponentProps={{ harcirahId: request._id }}
            />
        </div>
      );
    }

    if (request.status === 'completed' || request.status === 'cancelled') {
      return (
        <div>
          <RequestDetailModal
            isManager
            request={request}
          />
          <span>
                &nbsp;
          </span>
        </div>
      );
    }

    return (
      <span>
            Bilinmiyor
      </span>
    );
  }
}


export default AccountingActionView;



// WEBPACK FOOTER //
// ./src/components/actions/view/accounting/index.js